import styled from 'styled-components'

export const Container = styled.div`
	display: flex;
	column-gap: 8px;
`
